import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationCreateSavedDocumentThreadArgs,
  BackendSavedDocumentThread,
} from 'src/types/backend';

const MUTATION = gql`
  mutation CreateSavedDocumentThread(
    $projectId: ID!
    $anchor: SavedDocumentAnchorInput!
    $text: String!
  ) {
    createSavedDocumentThread(projectId: $projectId, anchor: $anchor, text: $text) {
      id
    }
  }
`;

type Variables = BackendMutationCreateSavedDocumentThreadArgs;
type Result = Pick<BackendSavedDocumentThread, 'id'>;

export const createSavedDocumentThread = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
